import translation from './mixins/translation'
import laravel from './mixins/laravel'
import routes from './mixins/routes'
import EventBus from './event-bus'
import registerComponents from './components'
import VueScrollTo from 'vue-scrollto'
import VueFriendlyIframe from 'vue-friendly-iframe'

export default {
    install (Vue) {
        Vue.use(VueFriendlyIframe)
        Vue.use(VueScrollTo)
        Vue.mixin(translation)
        Vue.mixin(laravel)
        Vue.mixin(routes)
        Vue.prototype.$bus = EventBus
        registerComponents(Vue)
    }
}
